import InvoicesUnifiedTable from "@/components/Organisms/InvoicesUnifiedTable";
import { INVOICE_TYPE } from "../invoices";

/**
 * AllInvoicesTable Component
 *
 * Wrapper component that displays all invoices using the unified invoices table.
 * This is a lightweight wrapper around InvoicesUnifiedTable with variant='all'.
 */
const AllInvoicesTable = () => {
  return <InvoicesUnifiedTable variant={INVOICE_TYPE.all} />;
};

export default AllInvoicesTable;
